'use strict';
const mmWidgets = require('./mm-widgets'),
	addPx = require('@mindmup/mapjs-core/src/util/px');
mmWidgets.fn.contextMenuWidget = function (contextMenuModel, mapContainer, container, optional) {
	return mmWidgets.each(this, function () {
		let timeoutId = false;
		const element = this,
			contextMenuEvent = (optional && optional.contextMenuEvent) || 'context',
			contextClasses = (optional && optional.contextClasses) || {
				r1: ['connectorSelected:argument-mapping', 'showNodeStyle'],
				r2: ['lineSelected'],
				c3: ['connectorSelected:fishbone'],
				c4: ['lineSelected', 'showNodeStyle'],
				c5: ['connectorSelected:argument-mapping']
			},
			clearScrollTimeout = function () {
				if (timeoutId) {
					timeoutId = false;
					window.clearTimeout(timeoutId);
				}
			},
			hide = function () {
				clearScrollTimeout();
				element.addClass('hidden');
				element.removeEventListener('mouseenter', mouseenter); // eslint-disable-line no-use-before-define
				element.removeEventListener('mouseout', mouseout); // eslint-disable-line no-use-before-define
				container.removeEventListener('click touch keydown', hide);
				mapContainer.removeEventListener('scroll', hide);
			},
			mouseenter = function () {
				container.removeEventListener('click', hide);
			},
			mouseout = function () {
				container.addEventListener('click', hide);
			},
			showAtPosition = function (x, y, sizeClasses) {
				let posX, posY;
				clearScrollTimeout();
				mapContainer.removeEventListener('scroll', hide);
				element.removeClass('top-arrow bottom-arrow left-arrow right-arrow hidden');
				Object.keys(contextClasses).forEach(sizeType => element.removeClass(sizeType));
				if (sizeClasses) {
					sizeClasses.forEach(size => element.addClass(size));
				}
				posX = x - 0.5 * element.outerWidth();
				posY = y - element.outerHeight() - 20;
				if (posY < 20) {
					posY = y + 20;
					element.addClass('top-arrow');
				} else {
					element.addClass('bottom-arrow');
				}
				if (posX < 0) {
					posX = x - 15;
					element.addClass('left-arrow');
				} else if ((posX + element.outerWidth()) > container.innerWidth()) {
					posX = x - element.outerWidth() + 15;
					element.addClass('right-arrow');
				}

				element.css({
					'left': addPx(posX),
					'top': addPx(posY)
				});
				if (!sizeClasses || !sizeClasses.length) {
					container.addEventListener('click', hide);
				}
				element.addEventListener('mouseenter', mouseenter);
				element.addEventListener('mouseout', mouseout);

				container.addEventListener('touch keydown', hide);
				timeoutId = window.setTimeout(function () {
					mapContainer.addEventListener('scroll', hide);
				}, 200);


			};

		contextMenuModel.addEventListener(contextMenuEvent, (context) => {
			if (!context || !context.position) {
				hide();
				return;
			}
			const sizeClasses = [];
			Object.keys(contextClasses).forEach(sizeType => {
				const values = contextClasses[sizeType];
				values.forEach((key) => {
					if (context[key]) {
						sizeClasses.push(sizeType);
					}
				});
			});
			showAtPosition(context.position.x, context.position.y, sizeClasses);
		});
		element.addEventListener('contextmenu', function (e) {
			e.preventDefault();
			e.stopPropagation();
			return false;
		});

		element.find('[data-mm-keep-context-menu]').addEventListener('click touch keydown', (e) => {
			e && e.stopPropagation();
		});

	});
};
